import { components } from '../../../types/be-schema';

// TODO get rid of this...
export type GeneralRawDealerType = {
  City: string;
  State: string;
  Dealership: string;
  Phone: string;
  DealerID: string;
  PostalCode: string;
};

// /dealership/dealer_info/{dealer_id}
export type RawDealerType = {
  Address: string;
  City: string;
  Country: string;
  DealerGroupName: string;
  DealerId: string;
  Dealership: string;
  DealershipType: 'Franchise' | 'Independent';
  Email: string[];
  Makes: string[];
  Phone: number;
  Postal: number;
  State: string;
  Benefits: string[];
};

export type DealerType = {
  dealerID: string;
  name: string;
  groupName: string;
  makes: string[];
  address: string;
  city: string;
  province: string;
  postalCode: string;
  phone: string;
  email: string[];
};

export type RawEditableDealerInfo = components['schemas']['EditableDealerInfo'];

export const WEEKDAYS = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
] as const;

export type Weekday = (typeof WEEKDAYS)[number];

// time is 24 hour time (i.e. "17:00")
export type Hours = Record<
  Weekday,
  { startTime: string; endTime: string } | null
>;

export interface DetailedBenefit {
  title: string;
  body: string;
}

export type EditableDealerInfo = {
  detailedBenefits: DetailedBenefit[];
  benefitsList: string[];
  showBenefitsSection: boolean;
  hoursOfOperation: Hours | null;
  showHours: boolean;
};
